import { API_BASE } from './api';

export const candidateService = {
  getAll: (api, params) => api.get('/candidates', { params }),
  getById: (api, id) => api.get(`/candidates/${id}`),
  create: (api, data) => api.post('/candidates', data),
  update: (api, id, data) => api.put(`/candidates/${id}`, data),
  togglePass: (api, id, passed) => api.put(`/candidates/${id}/pass-status`, { passed }),
  remove: (api, id) => api.delete(`/candidates/${id}`),
  exportCSV: (api) => api.exportCandidatesCSV ? api.exportCandidatesCSV() : window.open(`${API_BASE.replace('/api', '')}/api/export/candidates`, '_blank'),
};
